import { Theme } from 'styling/theme'
import { makeStyles } from '@material-ui/styles'

export const useStyles = makeStyles((theme: Theme) => ({
    wrapper: {
        background: theme.colors.black,

        '&::before': {
            content: '""',
            position: 'absolute',
            height: '100vh',
            width: '100%',
            zIndex: 1,

            backgroundImage: 'linear-gradient(to bottom, rgba(31, 37, 51, 0) 6%, #0e1117 calc(100vw / (5/2)))',
        },
    },
    coverImg: {
        width: '100%',
        backgroundSize: 'contain',
        backgroundAttachment: 'fixed',
        backgroundPosition: 'top',
        backgroundRepeat: 'no-repeat',
        position: 'absolute',
        paddingBottom: 'calc(100% / (5/2))',
    },
    content: (props: { items }) => ({
        zIndex: 2,
        paddingTop: 230,
        display: 'flex',
        flexWrap: 'wrap',
        justifyContent: props.items <= 3 ? 'center' : 'flex-start',
        '@media (min-width: 1024px)': {
            margin: 'auto',
            maxWidth: 1760,
            width: '100%',
        },
        '@media (max-width: 999px)': {
            justifyContent: props.items === 1 ? 'center ' : 'flex-start',
        },
        '@supports (margin: min(1px, 1px))': {
            paddingTop: 'min(calc(100% / (5/2)), 414px)',
        },
    }),
    section: {
        padding: 20,

        '& .react-multi-carousel-list': {
            zIndex: 999,
        },
    },
    showCardWrapper: {
        width: '100%',
        marginLeft: 10,
        marginRight: 10,
        marginBottom: 20,

        '@media (min-width: 649px)': {
            width: 'calc(50% - 20px)',
        },

        '@media (min-width: 1000px)': {
            width: 'calc(33.3% - 20px)',
        },

        '@media (min-width: 1280px)': {
            width: 'calc(25% - 20px)',
        },
    },
}))
